function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 4H6.00002C5.82321 4 5.65364 4.07024 5.52861 4.19526C5.40359 4.32029 5.33335 4.48986 5.33335 4.66667V19.3333C5.33335 19.5101 5.40359 19.6797 5.52861 19.8047C5.65364 19.9298 5.82321 20 6.00002 20H18C18.1768 20 18.3464 19.9298 18.4714 19.8047C18.5964 19.6797 18.6667 19.5101 18.6667 19.3333V4.66667C18.6667 4.48986 18.5964 4.32029 18.4714 4.19526C18.3464 4.07024 18.1768 4 18 4V4ZM16 17.3333H8.00002V16H16V17.3333ZM16 14H8.00002V12.6667H16V14ZM16 10.6667H8.00002V6.66667H16V10.6667Z",
  fill: "#8181A5"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(4 4)"
})));

function SvgTimelinePost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelinePost);
export default __webpack_public_path__ + "static/media/timeline_post.5d7bd133.svg";
export { ForwardRef as ReactComponent };